export enum IndexName {
  Assets = 'assets',
  PlaybackOptions = 'playbackOptions',
}
